import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { checkoutMutations, checkoutQueryKeys } from '@as-react/common-queries';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
import { basketActions } from '../../../redux/basket/actions/BasketActions.creators';
import { useOnVoucherChanges } from '../../../hooks/useOnVoucherChanges';
import { usePaymentState } from '../../../context/CheckoutPaymentContext';
import { VoucherBlock } from '../voucher/VoucherBlock';
export const PaymentVoucherBlock = () => {
    var _a;
    const { t } = useTranslation(I18N_NAMESPACES.buy);
    const [state] = usePaymentState();
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const { postSubmitVoucher } = checkoutMutations({ servicesEndpoint, defaultRequestParams });
    const { mutateAsync: postSubmitVoucherMutation } = useMutation(postSubmitVoucher);
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const { onVoucherChanges } = useOnVoucherChanges();
    const handleVoucherAddSuccess = (code) => __awaiter(void 0, void 0, void 0, function* () {
        dispatch(analyticsActions.voucherAdded(code));
        dispatch(basketActions.createGetAction());
        yield queryClient.refetchQueries({ queryKey: checkoutQueryKeys.getPaymentInfo() }); // refetch query from CheckoutPaymentContainer
        yield onVoucherChanges();
    });
    const handleVoucherSubmit = (code, webcode) => __awaiter(void 0, void 0, void 0, function* () {
        const appliedVoucher = yield postSubmitVoucherMutation({ code, webcode });
        return appliedVoucher;
    });
    const handleVoucherAddError = (message) => {
        message &&
            dispatch(analyticsActions.formsErrorMessage({
                ['BuyService._postVoucher']: message,
                ['buy-voucher.voucher-code_1']: message,
            }));
    };
    return (_jsx(VoucherBlock, { isPaymentPage: true, onAddError: handleVoucherAddError, onAddSuccess: handleVoucherAddSuccess, onSubmit: handleVoucherSubmit, validateRegex: (_a = state === null || state === void 0 ? void 0 : state.info) === null || _a === void 0 ? void 0 : _a.validateRegex, submitButtonLabel: t('buy.payment.voucher.submit') }));
};
